<div
  class="flex flex-col justify-center items-center p-8 text-center gap-y-6 relative transition-all duration-300 ease-in-out animate-fade-in"
>
  <div class="absolute right-10 top-10 cursor-pointer" (click)="onNoClick()">
    <mat-icon svgIcon="mat_solid:close"></mat-icon>
  </div>
  <h4 class="text-[24px] font-black">Besoin d’aide</h4>
  <p class="text-[16px]">
    Notre équipe est à votre disposition pour vous accompagner tout au long du processus
  </p>
  <a
    [href]="'tel:' + tel"
    class="border-2 border-primary text-center px-8 py-4 text-[16px] font-bold text-primary"
    >{{ telAf }}</a
  >
  <p class="text-[16px]">
    N'hésitez pas à nous contacter à
    <a [href]="'mailto:' + email" class="underline cursor-pointer">{{ email }}</a>
  </p>
</div>
